import React, {createContext, useContext} from 'react'

const PlantIdContext = createContext<string | undefined>(undefined)

export const usePlantUpmId = (): string => {
  const upmId = useContext(PlantIdContext)
  if (!upmId) {
    throw new Error('usePlantUpmId must be used within a PlantUpmIdProvider')
  }
  return upmId
}

interface PlantUpmIdProviderProps {
  upmId: string
  children: React.ReactNode
}

export const PlantUpmIdProvider: React.FC<PlantUpmIdProviderProps> = ({upmId, children}) => {
  return <PlantIdContext.Provider value={upmId}>{children}</PlantIdContext.Provider>
}
